export const DATE_TIME_FORMAT = 'dd MMM yyyy';
export const DATE_FORMAT = 'yyyy-MM-dd';
export const DATE_TIME_FORMAT_12H = 'dd MMM, hh:mm a';
export const FULL_DATE_TIME_FORMAT_12H = 'dd MMM yyyy, h:mma';
export const DATE_TIME_CALENDAR = 'dd MMM yyyy h:mma';
export const FILTER_PERIOD_TIME = {
	RECENT_TXN: 3,
	LAST_N_DAYS: 7,
	MONTH_TO_DATE: 31,
};

export const TIME_INTERVAL = {
	ONE_SECOND: 1000,
	THREE_SECONDS: 3000,
};
